import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Changelog } from '@vmspdb/definitions';
import { Observable } from 'rxjs';
import { IChangelogService } from '../contracts/changelog';

@Injectable({
  providedIn: 'root',
})
export class DefaultChangelogService implements IChangelogService {
  private readonly http = inject(HttpClient);

  changelog$(): Observable<Changelog> {
    return this.http.get<Changelog>('/CHANGELOG.json');
  }
}
